// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_Zj0","cls2":"ExportFormatModal-cls2_dkA ExportFormatModal-cls1_Zj0"};